import { Button, Checkbox, Container, Grid, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'
import { FiatCurrency, PaymentInstructionsDummy, PaymentInstructionsProd } from 'src/common/static'
import * as S from '../styles'
import { SummaryTableCard } from 'src/ui/SummaryTable'

interface PaymentInstructionsProps {
  amount: string | number
  fiatCurrency: FiatCurrency
  isSmallScreen?: boolean
  onProceed: () => void
}

const PaymentInstructions: React.FC<PaymentInstructionsProps> = ({
  amount,
  fiatCurrency,
  isSmallScreen,
  onProceed
}: PaymentInstructionsProps) => {
  const [checked, setChecked] = useState(false)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked)
  }

  let isTestEnv = true
  if (
    process.env.REACT_APP_API_URL?.includes('staging') ||
    process.env.REACT_APP_API_URL?.includes('sandbox') ||
    process.env.REACT_APP_API_URL?.includes('localhost')
  ) {
    isTestEnv = true
  } else {
    isTestEnv = false
  }

  return (
    <Stack spacing={3} sx={{ maxWidth: '100%', width: '100%' }}>
      <S.Row>
        <Typography variant="h5" fontWeight={600}>
          Transfer Details
        </Typography>
        <Typography variant="subtitle1" color="grey.700">
          Please complete the funds transfer to {isTestEnv ? 'QCAD Digital Trust (Pending)' : 'VersaBank'}, account
          details as follows:
        </Typography>
      </S.Row>
      <S.Row>
        <Container sx={{ backgroundColor: 'grey.100', borderRadius: 2, padding: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Typography variant="h6" fontWeight={600}>
                Payment Details
              </Typography>
              <Typography variant="subtitle1" color="grey.700">
                Amount (CAD)
              </Typography>
            </Grid>
            <Grid item textAlign="right" xs={8}>
              <Typography variant={isSmallScreen ? 'h5' : amount.toString().length > 10 ? 'h4' : 'h3'} fontWeight={600}>
                ${amount} {fiatCurrency}
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </S.Row>
      <S.Row>
        <Grid container direction="row" spacing={2} sx={{ width: '100%' }}>
          <Grid item xs={12} md={isSmallScreen ? 12 : 6}>
            <SummaryTableCard
              title="Wire Transfer (SWIFT)"
              data={isTestEnv ? PaymentInstructionsDummy[0].swift : PaymentInstructionsProd[0].swift}
            />
          </Grid>

          <Grid item xs={12} md={isSmallScreen ? 12 : 6}>
            <SummaryTableCard
              title="ACH Payment"
              data={isTestEnv ? PaymentInstructionsDummy[0].ach : PaymentInstructionsProd[0].ach}
            />
          </Grid>
        </Grid>
      </S.Row>

      <S.Row>
        <Stack direction="row" spacing={1} alignItems="center">
          <Checkbox checked={checked} onChange={handleChange} />
          <Typography variant="body2">
            I understand that this mint order will be initiated only after a transfer of a corresponding amount in fiat
            is received.
          </Typography>
        </Stack>
      </S.Row>

      <S.Row>
        <Button variant="contained" fullWidth size="large" onClick={onProceed} disabled={!checked}>
          Proceed
        </Button>
      </S.Row>
    </Stack>
  )
}

export default PaymentInstructions
